import type { HttpTypes } from "@medusajs/types"

export type VariantStockMessage = {
  tone: "in" | "low" | "out"
  label: string
  strong?: string
  suffix?: string
}

export const getVariantAvailableQty = (
  variant?: HttpTypes.StoreProductVariant
) => Math.max(0, Math.trunc(Number(variant?.inventory_quantity || 0)))

export const isTrackedVariant = (variant?: HttpTypes.StoreProductVariant) =>
  Boolean(variant?.manage_inventory)

export const isSelectableVariant = (variant?: HttpTypes.StoreProductVariant) => {
  if (!variant) {
    return false
  }

  if (!isTrackedVariant(variant)) {
    return true
  }

  if (variant.allow_backorder) {
    return true
  }

  return getVariantAvailableQty(variant) > 0
}

export const isOutOfStockVariant = (variant?: HttpTypes.StoreProductVariant) => {
  if (!variant || !isTrackedVariant(variant) || variant.allow_backorder) {
    return false
  }

  return getVariantAvailableQty(variant) <= 0
}

export const getVariantStockMessage = (
  variant?: HttpTypes.StoreProductVariant
): VariantStockMessage | null => {
  if (!variant) {
    return null
  }

  if (!isTrackedVariant(variant)) {
    return {
      tone: "in",
      label: "In stock",
    }
  }

  const qty = getVariantAvailableQty(variant)

  if (qty <= 0 && !variant.allow_backorder) {
    return {
      tone: "out",
      label: "Out of stock",
    }
  }

  if (qty <= 0 && variant.allow_backorder) {
    return {
      tone: "in",
      label: "Available for backorder",
    }
  }

  if (qty <= 5) {
    return {
      tone: "low",
      label: "Hurry,",
      strong: String(qty),
      suffix: "left only",
    }
  }

  return {
    tone: "in",
    label: "In stock",
    strong: String(qty),
    suffix: "pcs available",
  }
}
